import {Observable} from 'rxjs/Observable';
import {DigitalSignService} from '../services/digital-sign.service';
import {Utilities} from '@shared/utilities/utilities.model';
import {DigitalSignCheckLastDossier} from '../models/digital-sign-check-last-dossier.model';
import {DigitalSignOperatorStartedProcess} from '../models/digital-sign-started-operator-process.model';
import {DigitalSignDocument} from '../models/digital-sign-document.model';
import {DigitalSignNewDossier} from '../models/digital-sign-new-dossier';
import {DigitalSignSigner} from '../models/digital-sign-signer.model';
import {AttachedContractModel, CustomerContractModel} from '@cc-commons/models/contract-details.model';
import {BlobTypes} from '@shared/models/attached-file.model';
import {UploadFileService} from '@shared/service/upload-file.service';
import {UserV3Model} from '@shared/models/user-v-3.model';
import {CrossPermissionModel} from '@shared/models/user-permission.model';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';

export class DigitalSignUtilities {
	static environmentStatic: AppConfigEnvironment;
	static ORDERS_TYPE = 'orders';
    static CONTRACT_CLOSE_TYPE = 'contract_close';
    static USER_CHANGE = 'user_change';
	static ROLE_IR = 'IR';

	static ROLE_APPLICANT = 'richiedente';
	static CREATED = 10;

	static SENT = 20;
	static SIGNATURE_PROCESS_STARTED = 30;
	static IR_PROCESS_STARTED = 40;
	static IR_PROCESS_COMPLETED = 50;
	static IR_PROCESS_SIGNED = 60;
	static SIGNER_PROCESS_STARTED = 70;
	static SIGNER_PROCESS_COMPLETED = 80;
	static SIGNER_PROCESS_SIGNED = 90;
	static SIGNATURE_PROCESS_COMPLETED = 100;
	static ABORTED = 110;
	static ERROR = 120;
	static getGoBackRoute(type: string, resource_id: any): any {
		let route: any = ['/'];
		switch (type) {
			case DigitalSignUtilities.ORDERS_TYPE:
				route = ['/delivery/dashboard/orders/details', resource_id];
				break;
			case DigitalSignUtilities.CONTRACT_CLOSE_TYPE:
				// route = ['/' + ROOT_CONTRACT_CLOSING_SP + '/' + CCSPO_DASHBOARD + '/' + CCSPO_CONTRACTS_LIST + '/' + CCSPO_CONTRACT_DETAILS, resource_id];
				route = ['/contract-closing/sp/dashboard/contracts/details/', resource_id];
				break;
		}
		return route;
	}



	static startSignerProcess(digitalSignService: DigitalSignService, type: string, resource_id: any,
		ds_dossier_id: string, signer_id: string): Observable<any> {
		return new Observable<any>(observer => {
			digitalSignService.startSignerProcess(resource_id, type, ds_dossier_id, signer_id).subscribe(
				resp => {
					if (!Utilities.isVoid(resp)) {
						if (resp.status === 200) {
							observer.next(
								{
								success: (!Utilities.isVoid(resp) && resp.status === 200),
								values: resp.json(),
								error: null
							});
						} else {
							observer.error(DigitalSignUtilities.extractErrorMessageFromBE(resp));
						}
					} else {
						observer.error({ isErrorMessageFromBE: false, errorMessage: 'resp is NULL' });
					}
				}, error => {
					observer.error({ isErrorMessageFromBE: false, errorMessage: error });
				});
		});
	}

	static completeSignerProcess(digitalSignService: DigitalSignService, type: string, resource_id: any,
		ds_dossier_id: string, signer_id: string, body: any) {
		return new Observable<any>(observer => {
			digitalSignService.completeSignerProcess(resource_id, type, ds_dossier_id, signer_id, body).subscribe(
				resp => {
					if (!Utilities.isVoid(resp)) {
						if (resp.status === 200) {
							observer.next({
								success: true,
								values: {
									dsStartedProcess: new DigitalSignOperatorStartedProcess(resp.json())
								},
								error: null
							});
						} else {
							observer.error(DigitalSignUtilities.extractErrorMessageFromBE(resp));
						}
					} else {
						observer.error({ isErrorMessageFromBE: false, errorMessage: 'resp is NULL' });
					}
				}, error => {
					observer.error({ isErrorMessageFromBE: false, errorMessage: error });
				});
		});
	}

	static getSignerToken(digitalSignService: DigitalSignService, type: string, resource_id: any, ds_dossier_id: string): Observable<any> {
		return new Observable<any>(observer => {
			digitalSignService.getDossier(resource_id, type, ds_dossier_id).subscribe(
				(resp: DigitalSignCheckLastDossier) => {
					if (!Utilities.isVoid(resp) && resp.state !== DigitalSignUtilities.ERROR && resp.state !== DigitalSignUtilities.ABORTED && resp.state !== DigitalSignUtilities.SIGNATURE_PROCESS_COMPLETED) {
						observer.next({
							success: true,
							values: {
								operatorToken: resp.signers.IR1.process_session_key,
								operatorMobileNumber: resp.signers.IR1.mobile_number,
								customerToken: resp.signers.richiedente1.process_session_key,
								customerMobileNumber: resp.signers.richiedente1.mobile_number,
							},
							error: null
						});
					} else {
						observer.error(Utilities.isVoid(resp) ? 'resp in NULL' : 'resp.state: ' + resp.state);
					}
				}, error => {
					observer.error(error);
				});
		});
	}

	static base64ToArrayBuffer(base64: any) {
		const binary_string = window.atob(base64);
		const len = binary_string.length;
		const bytes = new Uint8Array(len);
		for (let i = 0; i < len; i++) {
			bytes[i] = binary_string.charCodeAt(i);
		}
		return bytes.buffer;
	}

	static extractOperatorSignedDocuments(body: any) {
		let docs = [];
		if (!Utilities.isVoid(body) && !Utilities.isVoid(body.DS) && !Utilities.isVoid(body.DS.body)
			&& !Utilities.isVoid(body.DS.body.signatures) && !Utilities.isVoid(body.DS.body.signatures.documents)) {
			docs = body.DS.body.signatures.documents;
		}
		return docs;
	}

	static extractErrorMessageFromBE(resp) {
		let errorMessage = 'Errore. Ripeti l\' operazione, se il problema persiste richiedi assistenza.';
        let isErrorMessageFromBE = false;
        // TODO: check if resp 504
		if (!Utilities.isVoid(resp) && resp.status !== 404 && resp.status !== 504) {
			const parsedResp = resp.json();
			if (!Utilities.isVoid(parsedResp.error) && !Utilities.isVoid(parsedResp.error.details)
				&& !Utilities.isVoid(parsedResp.error.details.error)) {
				isErrorMessageFromBE = true;
				errorMessage = parsedResp.error.details.error;
			}
			// check if contains json object and parse it to recover errorMessage
			if (resp.json() && resp.json().message && resp.json().message.indexOf('{') > 0 && resp.json().message.indexOf('}') > 0
			&& resp.json().message.indexOf('}') > resp.json().message.indexOf('{') && resp.json().message.length > resp.json().message.indexOf('}')) {
				try {
					const messageObject: any = JSON.parse(resp.json().message.substring(resp.json().message.indexOf('{'), resp.json().message.indexOf('}') + 1 ));
					if (messageObject && messageObject.errorMessage) {
						errorMessage = messageObject.errorMessage;
						isErrorMessageFromBE = true;
					}
				} catch (e) {
					return {
						isErrorMessageFromBE: isErrorMessageFromBE,
						errorMessage: errorMessage
					};
				}
			}
		}
		return {
			isErrorMessageFromBE: isErrorMessageFromBE,
			errorMessage: errorMessage
		};
	}

	static extractErrorMessageFromBEUC(resp) {
		let errorMessage = 'Errore. Ripeti la tua ultima operazione, se il problema persiste richiedi assistenza.';
        let isErrorMessageFromBE = false;
        // TODO: check if resp 504
		if (!Utilities.isVoid(resp) && resp.status !== 404 && resp.status !== 504) {
			const parsedResp = resp.json();
			if (!Utilities.isVoid(parsedResp.message)) {
				isErrorMessageFromBE = true;
				errorMessage = parsedResp.message;
			}
		}
		return {
			isErrorMessageFromBE: isErrorMessageFromBE,
			errorMessage: errorMessage
		};
	}

	static createDigitalSignNewDossierForRedelivery(customer: CustomerContractModel,
		user: UserV3Model,
		digitalSignatureProperties: CrossPermissionModel,
		documents: AttachedContractModel[]): DigitalSignNewDossier {

		const dsNewDossier = new DigitalSignNewDossier();
		const dsCustomerSigner = new DigitalSignSigner().settingSignerFromCustomer(customer, 1);

		dsNewDossier.addSigner(dsCustomerSigner);

		// //TODO remove
		// if (DigitalSignUtilities.environmentStatic.environment === 'local') {
		// 	dsNewDossier.addSigner(new DigitalSignSigner(DigitalSignMocks.operator));
		// } else {
		// 	dsNewDossier.addSigner(new DigitalSignSigner().settingSignerFromUser(user.personal_details, digitalSignatureProperties, 1));
		// }

		dsNewDossier.addSigner(new DigitalSignSigner().settingSignerFromUser(user.personal_details, digitalSignatureProperties, 1));

		for (const document of documents) {
			dsNewDossier.addDocument(DigitalSignUtilities.exportDocument(document, dsCustomerSigner.infocert_signer_id));

		}

		return dsNewDossier;
	}

	static exportDocument(file: AttachedContractModel, infocert_signer_id: string) {
		const result = new DigitalSignDocument();
		if (!Utilities.isVoid(file)) {
			result.client_document_id = Utilities.getUUID();
			result.infocert_signer_id = infocert_signer_id;
			result.infocert_document_id = file.description;
			result.infocert_document_type = file.description;
			result.policy_compose = false;
			result.policy_sign = false;
			result.policy_archive = false;
			result.file_manager_id = file.uuid;
			result.signature_fields = [];
		}
		return result;
	}

	static checkBlobTypePersonalDocument(documentsAdded: string[]): boolean {
		return Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.PATENTE, BlobTypes.CODICE_FISCALE])
			|| Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.PATENTE, BlobTypes.CODICE_FISCALE_FRONTE, BlobTypes.CODICE_FISCALE_RETRO])
			|| Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.PATENTE_FRONTE, BlobTypes.PATENTE_RETRO, BlobTypes.CODICE_FISCALE])
			|| Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.PATENTE_FRONTE, BlobTypes.PATENTE_RETRO, BlobTypes.CODICE_FISCALE_FRONTE, BlobTypes.CODICE_FISCALE_RETRO]);
	}

	static getDSDocumentForCC(contractNumber: string, plate: string, societyName: string,
		signerCompleteName: string, signerFiscalCode: string, fileManagerID: string) {
		return new DigitalSignDocument(
			{
				client_document_id: Utilities.getUUID(),
				infocert_document_id: 'ALD-vdr1',
				infocert_document_type: BlobTypes.VERBALE_DI_RICONSEGNA,
				policy_compose: false,
				policy_sign: true,
				policy_archive: true,
				file_manager_id: fileManagerID,
				signature_fields: [
					{
						signer_id: 'richiedente1',
						name: 'driver_signature',
						reason: 'Dichiarazione del sottoscrittore',
						location: ''
					},
					{
						signer_id: 'IR1',
						name: 'ir_signature',
						reason: 'Anagrafica, documentazione di bordo e stato d\'uso',
						location: ''
					}
				],
				archiving_policy: {
					document_class: 'verbali_service_point',
					attributes: {
						doc_type: BlobTypes.VERBALE_DI_RICONSEGNA,
						file_manager_id: fileManagerID,
						order_id: contractNumber,
						plate: plate,
						reference_id: contractNumber,
						reference_type: UploadFileService.CONTRACT_CLOSING_RESOURCE_TYPE,
						signer_complete_name: signerCompleteName,
						signer_fiscal_code: signerFiscalCode,
						society_name: societyName
					}
				}
			});
	}
}
